import React from "react";
import { motion } from "framer-motion";
import AnimatedHeading from "./AnimatedHeading";

// COPY LOCKED — do not edit
const ITEMS = [
    { n: "01", h: "Operatori, non intermediari", b: "I soci fondatori gestiscono posizioni importanti come utenti del dispacciamento (UDD). Conosciamo il mercato perché ci stiamo dentro." },
    { n: "02", h: "La macchina è la nostra",     b: "Ti diamo lo stesso sistema con cui operiamo: piattaforma, fatturazione, adempimenti, contabilità, legale. Pronto, chiavi in mano." },
    { n: "03", h: "Un referente che risponde",   b: "Una persona dedicata ti segue, dall'attivazione in poi. Niente call center, niente ticket nel vuoto." },
];

export default function SectionTrust() {
    return (
        <section className="lp-section lp-section-alt" aria-labelledby="s-trust">
            <div className="lp-container">
                <div className="lp-section-head">
                    <motion.div
                        className="lp-eyebrow lp-section-eyebrow"
                        initial={{ opacity: 0, y: 12 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <span className="lp-eyebrow-accent">◆</span> &nbsp;/&nbsp; Chi siamo
                    </motion.div>
                    <AnimatedHeading
                        as="h2"
                        id="s-trust"
                        className="lp-h2"
                        text="Non veniamo da fuori. Il mercato dell'energia lo operiamo già."
                    />
                    <motion.p
                        className="lp-body-lg lp-section-sub"
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
                    >
                        Dietro ENERLEFT ci sono operatori che sul mercato dell'energia lavorano ogni giorno. Non ti spieghiamo come funziona: lo facciamo.
                    </motion.p>
                </div>
                <motion.div
                    className="lp-trust"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ staggerChildren: 0.12 }}
                >
                    {ITEMS.map((it) => (
                        <motion.div
                            key={it.n}
                            className="lp-trust-item"
                            data-testid={`trust-${it.n}`}
                            variants={{
                                hidden: { opacity: 0, y: 22 },
                                visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
                            }}
                        >
                            <div className="lp-trust-num">{it.n}</div>
                            <h3 className="lp-trust-h">{it.h}</h3>
                            <p className="lp-trust-body">{it.b}</p>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
}
